var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordBoxHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 250,
    viewBox: "0 0 124 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3725 262.5C11.6281 243.609 10.1676 176.141 11.381 157.156C12.3867 141.406 34.0208 139.237 31.5409 145.789C29.1414 152.129 -3.69848 157.156 5.01545 94.1533C6.44654 83.8181 8.32342 69.0191 9.3725 58.6303C10.9646 42.8796 12.7944 34.21 15.0698 30.3594C23.7827 15.7347 30.9693 76.4756 25.457 75.7216C21.4592 75.1753 24.9153 19.6723 28.759 13.5932C32.4955 7.69171 38.8121 8.28823 41.5429 22.102C45.2286 40.8688 40.3388 71.4856 39.1962 67.6786C38.0235 63.7678 39.1974 14.2836 40.873 9.52818C43.2188 2.99999 47.5751 3 47.5751 3C58.9685 3 60.6426 68.684 55.9512 67.6786C52.6002 68.0138 56.0463 11.5322 64.3299 11.7132C79.7445 12.0483 67.0093 81.3282 81.083 103.872C84.4339 109.234 98.5623 79.5721 115.763 81.7069C118.967 81.4354 121.795 84.9609 119.784 87.4341C98.8431 113.239 99.3686 134.901 74.2358 145.96C69.1791 148.185 67.3299 220.656 67.3299 262.5",
    stroke: "#5DA7EB",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordBoxHand);
export default __webpack_public_path__ + "static/media/recordBoxHand.c2bf95ea5521d963fe76a102b48d4e47.svg";
export { ForwardRef as ReactComponent };